/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  AdminObjectState,
  SignalAdminResourceApiBase,
  SignalAdminResourceListParams,
  SignalAdminResourcePage
} from '../../common/controller/signal-admin-resource-api';
import {validityCalculation} from './coupon-commons';

export interface CouponModel {
  id: string;
  name?: string;
  description?: string;
  code?: string;
  validity?: string;
  validFrom?: Date | string | null;
  validTo?: Date | string | null;
  modValidFrom?: Date | string | null;
  modValidTo?: Date | string | null;
  expiry?: string | null;
  expiryNumber?: number;
  expiryUnit?: string;
  type?: string;
  couponStatus?: string;
  couponEndDateType?: string;
  oneTimeValidity?: boolean;
  allProducts?: boolean;
  products?: CouponProduct[];
  claimableAts?: string[];
  discountMonetary?: any;
  discountPercentage?: number;
  objectState?: AdminObjectState;
  validationWarnings?: any[];
}

export interface CouponProduct {
  id: string;
  name?: string;
  description?: string;
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class CouponApiService extends SignalAdminResourceApiBase<CouponModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'coupons');
  }

  override list(params: SignalAdminResourceListParams): Observable<SignalAdminResourcePage<CouponModel>> {
    return super.list(params).pipe(
      map((page) => ({
        ...page,
        results: (page.results || []).map((coupon) => {
          validityCalculation(coupon);
          return coupon;
        })
      }))
    );
  }

  searchProducts(query: string): Observable<CouponProduct[]> {
    const normalizedQuery = (query || '').trim();
    const searchQuery = normalizedQuery.length < 3 && !normalizedQuery.endsWith('*')
      ? normalizedQuery + '*'
      : normalizedQuery;
    return this.client.request<{searchResults?: CouponProduct[]}>({
      method: 'GET',
      url: this.resourceUri('search'),
      params: {q: searchQuery, types: 'Product', objectState: 'ACTIVE'}
    }).pipe(map((response) => response.searchResults || []));
  }
}
